<div class="venue-applications">
  <div class="venue-applications__filters grid align-items-end mb-4">
    <div class="col-3 col-sm-12">
      <div class="ui-input__placeholder"><p>С</p></div>
      <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="from" /></div>
    </div>
    <div class="col-3 col-sm-12">
      <div class="ui-input__placeholder"><p>По</p></div>
      <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="to" /></div>
    </div>
    <div class="col-3 col-sm-12">
      <div class="ui-input__placeholder"><p>Статус</p></div>
      <p-dropdown [(ngModel)]="status" [options]="statusOptions" optionLabel="name" optionValue="value" placeholder="Все статусы" styleClass="p-dropdown__bulletins"></p-dropdown>
    </div>
    <div class="col-3 col-sm-12 venue-applications__filter-actions">
      <button type="button" class="ui-buttons ui-buttons__blue-small mr-2" (click)="onApplyFilters()">Применить</button>
      <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onResetFilters()">Сбросить</button>
    </div>
  </div>
  <p class="txt-caption venue-applications__error mb-3" *ngIf="loadError">{{ loadError }}</p>
  <div class="ui-loader ui-loader__page-light" *ngIf="loading"></div>
  <p class="txt-caption" *ngIf="!loading && !items.length && !loadError">Заявок пока нет.</p>
  <div class="venue-applications__list" *ngIf="!loading && items.length">
    <div class="venue-applications__card mb-3" *ngFor="let item of items">
      <h5 class="m-0">{{ item.performer?.name || 'Артист' }}</h5>
      <p class="txt-caption mb-1">Статус: {{ statusLabel(item.status) }}</p>
      <p class="mb-2" *ngIf="item.message">{{ item.message }}</p>
      <div *ngIf="canAccept(item) || canDecline(item)">
        <button type="button" class="ui-buttons ui-buttons__blue-small mr-2" [disabled]="actionLoadingId === item.requestId" (click)="accept(item)">Принять</button>
        <button type="button" class="ui-buttons ui-buttons__light-small" [disabled]="actionLoadingId === item.requestId" (click)="decline(item)">Отклонить</button>
      </div>
    </div>
  </div>
  <div class="venue-applications__pager mt-3" *ngIf="!loading && (page > 1 || hasMore)">
    <button type="button" class="ui-buttons ui-buttons__light-small mr-2" [disabled]="page <= 1" (click)="onPrevPage()">Назад</button>
    <span class="txt-caption mr-2">Стр. {{ page }}</span>
    <button type="button" class="ui-buttons ui-buttons__light-small" [disabled]="!hasMore" (click)="onNextPage()">Далее</button>
  </div>
</div>
